import React, { useContext, useEffect } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { useModal } from '../../../hooks/useModal'
import { Context } from '../../../Store'
import { Trans, useTranslation } from 'react-i18next'
import { isMobile } from 'react-device-detect'
import { TickIcon } from '../../../assets/icons/TickIcon'
import { BOOKING_FLEXIBILITY_STATUS } from '../../../constants'

// --- Styles ---
const paperStyles = {
  borderRadius: '20px',
  boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.08)',
  padding: isMobile ? '20px 18px 25px 18px' : '31px 41px 34px 36px',
}

const dialogTitleBoxStyles = {
  position: 'relative',
  textAlign: 'flex-start',
}

const closeButtonStyles = {
  position: 'absolute',
  right: 0,
  top: 0,
}

const titleTextWrapperStyles = {
  display: 'inline-block',
  borderRadius: '3px',
  background: '#DCF2F4',
  padding: '7px 8px',
}

const titleTextStyles = {
  fontSize: '18px',
  fontWeight: 700,
  color: '#0C9D9D',
  margin: 0,
}

const headingTextStyles = {
  fontSize: isMobile ? '18px' : '20px',
  fontWeight: 600,
  color: '#000',
  marginBottom: 24,
}

const benfitTextStyles = {
  fontSize: isMobile ? '14px' : '18px',
  fontWeight: 400,
  color: '#394555',
  margin: 0,
}

const dialogActionButtonStyles = {
  background: '#0C9D9D',
  color: '#FFFFFF',
  padding: '12px 24px',
  borderRadius: '6px',
}

const EasyPayBenfitRow = ({ benefit_text }) => {
  return (
    <Box item style={{ display: 'flex', gap: '5px' }} key={`easypay-benefit-${benefit_text}`}>
      <TickIcon fill="#394555" width="11px" height="20px" />
      <Typography style={benfitTextStyles}>
        <Trans i18nKey={benefit_text} components={{ 1: <span style={{ fontWeight: 'bold' }} /> }} />
      </Typography>
    </Box>
  )
}

const EASYPAY_BENEFITS = [
  'easyPayPlan.benefit.benefit_1',
  'easyPayPlan.benefit.benefit_2',
  'easyPayPlan.benefit.benefit_3',
  'easyPayPlan.benefit.benefit_4',
  'easyPayPlan.benefit.benefit_5',
]

export const EasyPayPlanBenefitsDialog = () => {
  const { t } = useTranslation()
  const [_,dispatch] = useContext(Context)
  const { isOpen, onOpen, onClose } = useModal()

  const handleClose = () => {
    dispatch({ type: 'SET_FLEXIBILITY_STATUS', payload: BOOKING_FLEXIBILITY_STATUS.READY })
    onClose()
  }

  return (
    <>
      <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ style: paperStyles }}>
        <DialogTitle disableTypography style={{ padding: 0, marginBottom: '32px' }}>
          <Box style={dialogTitleBoxStyles}>
            <Box style={titleTextWrapperStyles}>
              <Typography style={titleTextStyles}>{t('easyPayPlan.title')}</Typography>
            </Box>
            <IconButton aria-label="close" onClick={onClose} size="small" style={closeButtonStyles}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent style={{ padding: 0 }}>
          <Typography style={headingTextStyles}>{t('easyPayPlan.benefit.title')}</Typography>

          <Grid style={{ gap: '24px', display: 'flex', flexDirection: 'column' }}>
            {EASYPAY_BENEFITS.map((benefit) => (
              <EasyPayBenfitRow benefit_text={benefit} key={`easypay-benefit-${benefit}`} />
            ))}
          </Grid>
        </DialogContent>
        <DialogActions style={{ marginTop: 24 }}>
          <Button onClick={handleClose} style={dialogActionButtonStyles} autoFocus>
            {t('easyPayPlan.benefit.bookWithEasyPay')}
          </Button>
        </DialogActions>
      </Dialog>

      <Box style={{ display: 'inline-block', cursor: 'pointer', borderRadius: 3, padding: '7px 8px', background: '#0C9D9D' }} onClick={onOpen}>
        <Typography style={{ fontSize: isMobile ? '12px' : '14px', fontWeight: 700, margin: 0, color: '#FFFFFF', letterSpacing: '3%' }}>
          {t('easyPayPlan.benefit.discoverOtherAdvantages')}
        </Typography>
      </Box>
    </>
  )
}
